module.exports = __webpack_public_path__ + "static/media/painter.76cb6442.svg";